// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__-2o5u","total":"Cart_total__HsTey","actions":"Cart_actions__-J6kv","button--alt":"Cart_button--alt__-FU16","button":"Cart_button__WS39L"};